import { Injectable, signal, effect, inject } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { Plan, User as UserM } from '@models/user.model';
import { Api } from '@services/api.service';
import { tap, map, switchMap, shareReplay } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class User{
	readonly api=inject(Api);
	readonly user=signal<UserM | null>(null);				//utilisateur courant
  private recaptcha=inject(ReCaptchaV3Service);

	constructor(){
		if(localStorage.getItem('user'))
			this.user.set(JSON.parse(localStorage.getItem('user')));

		effect(() => {
			if(this.user())
				localStorage.setItem('user', JSON.stringify(this.user()));
			else{
				localStorage.removeItem('user');
				localStorage.removeItem('session');
			}
		});
	}

	setSession(token: string){
		localStorage.setItem('session', token);
	}

	getSession(){
		return localStorage.getItem('session');
	}

	isConnected(){
		return (this.user()!=null);
	}

	getImg(){
		if(this.user()?.img)
			return `${environment.imgUrl}/users/avatars/${this.user().img}`;
		else
			return null;
	}

	hasRight(right: string){
		if(!this.user())
			return false;
		return this.user().rights.filter((val) => val==right).length>0;
	}

	getInitial(){
		return `${this.user()?.name.trim().charAt(0).toUpperCase()}${this.user()?.lastname.trim().charAt(0).toUpperCase()}`;
	}

	subscribe(user: FormData){
		return this.recaptcha.execute('subscribe').pipe(
			tap(token => user.append('token', token)),
			switchMap(() => this.api.post<UserM>('/users/subscribe', user))
		);
	}

	getSubscriptions(user: string){
		return this.api.get<Plan[]>(`/subscriptions/${user}`);
	}

	forgot(email: string){
		return this.api.get<any>(`/users/forgot`, { email });
	}

	connect(email: string, pass: string){
		return this.api.post<ConnectResponse>('/users/connect', {email, pass})
			.pipe(
				tap(response => this.user.set(response.user)),
				tap(response => this.setSession(response.session)),
				map(response => response.user)
			);
	}

	unlog(){
		return this.api.get<any>('/users/unlog')
			.pipe(
				tap(() => this.user.set(null))
			);
	}

	getUser(ident: string){
		return this.api.get(`/users/${ident}`)
			.pipe(
				shareReplay(1)
			);
	}

	getMyParams(){
		return this.api.get<ParamUser[]>(`/users/my-params`);
	}

	setMyParams(params: ParamApiQuery){
		return this.api.post<ParamUser[]>(`/users/my-params`, params);
	}

	setUser(ident: string, user: FormData){
		return this.api.post<User>(`/users/${ident}`, user);
	}

	search(q: string, start: number=0, length: number=100){
		let params: any={start, length};
		if(q)
			params.q=q;
		return this.api.get<UserM[]>('/users/search', params);
	}
}

interface ConnectResponse{
	user: UserM;
	session: string;
}

export const PARAM_DEFAULT_MARKET="default.market";
export const PARAM_DEFAULT_CONDITION="default.condition";
export interface ParamUser{
	user: string;
	name: string;
	value: string;
}

export interface ParamApiQuery{
	market: string;
	scanCondition: string;
}